module.exports = __webpack_public_path__ + "img/tomas-lupinucci.376406ef.jpg";